import React, { useState, useEffect } from 'react';
import CountUp from "react-countup";
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Spinner } from 'reactstrap';
import { ecomWidgets } from "../../common/data";
import { getDashboardStats } from "../../api/ecommerce";
import { getUserRole } from "../../helpers/role_helper";
import { getLoggedinUser } from "../../api";

const Widgets = () => {
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const role = getUserRole(getLoggedinUser());

    useEffect(() => {
        getDashboardStats()
            .then((res) => {
                const d = res?.data || res;
                setStats(d);
            })
            .catch(() => setStats(null))
            .finally(() => setLoading(false));
    }, []);

    const getWidgetValue = (item) => {
        if (loading || !stats) return item.counter;
        if (item.label === "Total Earnings") return stats.revenue / 1000;
        if (item.label === "Orders") return stats.ordersCount || 0;
        if (item.label === "Customers") return stats.customersCount || 0;
        if (item.label === "My Balance") return stats.revenue / 1000;
        return item.counter;
    };

    const footerLink = (item) => {
        if (item.label === "Orders") {
            return role === "seller" ? "/seller/orders" : "/orders";
        }
        if (item.link === "Withdraw money" || item.label === "My Balance") {
            return role === "seller" ? "/seller-draw" : "/vendor-withdraw";
        }
        return "#";
    };

    return (
        <React.Fragment>
            {ecomWidgets.map((item, key) => (
                <Col xl={3} md={6} key={key}>
                    <Card className="card-animate">
                        <CardBody>
                            <div className="d-flex align-items-center">
                                <div className="flex-grow-1 overflow-hidden">
                                    <p className="text-uppercase fw-medium text-muted text-truncate mb-0">{item.label}</p>
                                </div>
                                <div className="flex-shrink-0">
                                    <h5 className={"fs-14 mb-0 text-" + item.badgeClass}>
                                        {item.badge ? <i className={"fs-13 align-middle " + item.badge}></i> : null} {item.percentage} %
                                    </h5>
                                </div>
                            </div>
                            <div className="d-flex align-items-end justify-content-between mt-4">
                                <div>
                                    <h4 className="fs-22 fw-semibold ff-secondary mb-4">
                                        {loading ? (
                                            <Spinner size="sm" />
                                        ) : (
                                            <span className="counter-value">
                                                <CountUp
                                                    start={0}
                                                    prefix={item.prefix}
                                                    suffix={item.suffix}
                                                    separator={item.separator}
                                                    end={parseFloat(getWidgetValue(item)) || 0}
                                                    decimals={item.decimals}
                                                    duration={2}
                                                />
                                            </span>
                                        )}
                                    </h4>
                                    <Link to={footerLink(item)} className="text-decoration-underline">{item.link}</Link>
                                </div>
                                <div className="avatar-sm flex-shrink-0">
                                    <span className={"avatar-title rounded fs-3 bg-" + item.bgcolor + "-subtle"}>
                                        <i className={`text-${item.bgcolor} ${item.icon}`}></i>
                                    </span>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>))}
        </React.Fragment>
    );
};

export default Widgets;